import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const EmergencyContactForm: React.FC<{
  form: UseFormReturn<any, any, undefined>;
}> = ({ form }) => {
  const { t } = useTranslation();

  const emergencyContactErrors = form.formState.errors.emergencyContact;

  return (
    <div className="grid grid-cols-1 gap-6">
      <div className="grid gap-6 md:grid-cols-2">
        <FormField
          control={form.control}
          name="emergencyContact.fullName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t('activity.formEdit.emergencyContact.fullName')}
              </FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="emergencyContact.phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t('activity.formEdit.emergencyContact.phone')}
              </FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div>
        {emergencyContactErrors?.root && (
          <div className="mt-2 text-red-500">
            {t(emergencyContactErrors.root?.message as string)}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmergencyContactForm;
